<template>
  <component
    :is="componentTypes[filter.type]"
    v-model="modelValue"
    v-bind="{ filter, layout, loading, currency }"
  />
</template>

<script lang="ts" setup>
import type { FilterItem } from '#types/filters'

const { layout = 'flex' } = defineProps<{
  filter: FilterItem
  layout?: 'flex' | 'grid'
  loading?: boolean
  currency?: string
}>()

const modelValue = defineModel<string[]>()

const componentTypes = {
  Checkbox: resolveComponent('filter-option-checkbox'),
  ColorSwatch: resolveComponent('filter-option-color-swatch'),
  ImageCheckbox: resolveComponent('filter-option-checkbox'),
  PriceInput: resolveComponent('filter-option-price-input'),
  TileExpanded: resolveComponent('filter-option-tile-expanded'),
  TilePercentage: resolveComponent('filter-option-tile-percentage'),
  TileImage: resolveComponent('filter-option-tile-image'),
  TileSquare: resolveComponent('filter-option-tile-square')
}
</script>
